import { Type, type Static } from "@fastify/type-provider-typebox";

export enum InboundShipmentType {
  SPD = "SPD",
  LTL = "LTL",
}

export enum DimensionUnit {
  INCHES = "inches",
  CENTIMETERS = "centimeters",
  INCHES_IN = "IN", // sometimes spapi returns this
}

export enum WeightUnit {
  POUNDS = "pounds",
  KILOGRAMS = "kilograms",
}

export enum CurrencyCode {
  USD = "USD",
  GBP = "GBP",
}

// https://developer-docs.amazon.com/sp-api/docs/fulfillment-inbound-api-v2024-03-20-reference#freightinformation
export const FBAFreightClasses = [
  "NONE",
  "FC_500",
  "FC_400",
  "FC_300",
  "FC_250",
  "FC_200",
  "FC_175",
  "FC_150",
  "FC_125",
  "FC_110",
  "FC_100",
  "FC_92_5",
  "FC_85",
  "FC_77_5",
  "FC_70",
  "FC_65",
  "FC_60",
  "FC_55",
  "FC_50",
] as const;

export const Weight = Type.Object({
  Value: Type.Number(),
  Unit: Type.Enum(WeightUnit),
});

export const Amount = Type.Object({
  Value: Type.Number(),
  CurrencyCode: Type.Enum(CurrencyCode),
});

export const InboundLTLInfo = Type.Object({
  boxCount: Type.Optional(Type.Number({ maximum: 5000 })),
  freightClass: Type.String(),
  freightReadyDate: Type.String(),
  totalWeight: Type.Optional(Weight),
  sellerDeclaredValue: Amount,

  contactId: Type.Optional(Type.Number()),
  contactName: Type.Optional(Type.String()),
  contactEmail: Type.Optional(Type.String()),
  contactPhone: Type.Optional(Type.String()),
});

export const InboundSPInfo = Type.Object({
  carrierName: Type.Optional(Type.String()),
});

export const InboundTransportBody = Type.Object({
  ltlInfo: Type.Optional(InboundLTLInfo),
  spInfo: Type.Optional(InboundSPInfo),
});

export type InboundTransportBody = Static<typeof InboundTransportBody>;


export const InboundTransportResponse = Type.Object({
  id: Type.Integer(),
  estimateAmount: Type.Number(),
  estimateCurrency: Type.Enum(CurrencyCode),
  previewFreightClass: Type.String(),
  previewFreightPickupDate: Type.String(),
  confirmDeadline: Type.String(),
  voidDeadline: Type.String(),
  transportSubmissionError: Type.Optional(Type.String()),
  status: Type.String(), // @TODO shipment enum
});
export type InboundTransportResponse = Static<typeof InboundTransportResponse>;
